<template>
  <div class="is-fullwidth">
    <div class="columns is-multiline is-vcentered mb-2">
      <div class="column is-12-tablet is-6-desktop">
        <div class="field has-addons">
          <p class="control is-expanded">
            <input
              class="input"
              v-model="search"
              placeholder="Search PO Number, Client Name or Garment"
            />
          </p>
          <p class="control">
            <span class="button is-static">{{ filteredOrders.length }} orders</span>
          </p>
          <p class="control">
            <span class="button is-static">{{ totalFilteredGarments }} garments</span>
          </p>
        </div>
      </div>

      <div class="column is-12-tablet is-6-desktop has-text-right-desktop">
        <div class="buttons is-right">
           <button
            class="button"
            :class="{ 'is-success': selected_location_id == row.id }"
            v-for="row in locations"
            :key="row.id"
            @click="selected_location_id = row.id"
            :disabled="loading==true"
          >
            {{ row.name }}
          </button>
          <button
            
            class="button"
            :class="{ 'is-info': filterStrabaneOffshore }"
            @click="filterStrabaneOffshore = !filterStrabaneOffshore"
             :disabled="loading==true"
          >
            Strabane → Offshore
          </button>
        </div>
      </div>


    </div>

    <div class="columns is-multiline mb-1">
      <div class="column is-12-tablet is-6-desktop" v-for="item in summaryRows" :key="item.key">
        <article class="message" :class="[{ 'is-link': selectedStage !== item.key, 'is-success': selectedStage === item.key }]" @click="toggleStage(item.key)" style="cursor: pointer;">
          <div class="message-body py-3">
            <div class="is-flex is-justify-content-space-between is-align-items-center">
              <strong>{{ item.label }}</strong>
              <span>
                <strong>{{ item.orders }}</strong> orders / <strong>{{ item.garments }}</strong> garments
              </span>
            </div>
          </div>
        </article>
      </div>
    </div>

    <table class="table is-fullwidth is-hoverable is-size-7" id="overviewreporttable">
      <thead>
        <tr>
          <th>PO Number</th>
          <th>Client</th>
          <th>Order Date</th>
          <th>Delivery Date</th>
          <th>Garment</th>
          <th>Fabric</th>
          <th>Type</th>
          <th class="has-text-right">Qty</th>
          <th>Print Location</th>
          <th>Printing</th>
          <th>Rolls Location</th>
          <th>Fabric Rolls</th>
          <th>Cutting Location</th>
          <th>Gerber Cutting</th>
          <th>Makeup</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="loading === true">
          <td colspan="15">
            <div class="notification is-info mb-0">Loading orders ...</div>
          </td>
        </tr>
        <tr v-if="loading === false && filteredOrders.length === 0">
          <td colspan="15">
            <div class="notification is-warning mb-0">There are no matching orders</div>
          </td>
        </tr>

        <tr v-for="order in filteredOrders" :key="order.orderID">
          <td>
            <router-link :to="'/printing-cutting/view-order/' + order.ponumber" target="_blank">
              {{ order.ponumber }}
            </router-link>
          </td>
          <td>{{ order.clientname }}</td>
          <td>{{ order.orderdate }}</td>
          <td>{{ order.deliverydate }}</td>
          <td>{{ order.garmentname }}</td>
          <td>{{ order.fabric_name }}</td>
          <td>{{ getOrderType(order) }}</td>
          <td class="has-text-right">{{ toNumber(order.total_qty) }}</td>
<td>{{ getLocationName(order.print_location_id) }}</td>
          <td>
            <span class="tag" :class="getStatusTagClass(isPrintingComplete(order), isPrintingApplicable(order))">
              <span v-if="!isPrintingApplicable(order)" class="has-text-grey">{{ isPrintingActuallyComplete(order) ? 'Completed' : 'Not applicable' }}</span>
              <span v-else>{{ isPrintingComplete(order) ? 'Complete' : (printingRemaining(order) + ' remaining') }}</span>
            </span>
          </td>
          
<td>{{ getLocationName(order.fabric_print_location_id) }}</td>
          <td>
            <span class="tag" :class="getStatusTagClass(isRollsComplete(order), isRollsApplicable(order))">
              <span v-if="!isRollsApplicable(order)" class="has-text-grey">{{ isRollsActuallyComplete(order) ? 'Completed' : 'Not applicable' }}</span>
              <span v-else>{{ isRollsComplete(order) ? 'Complete' : (rollsRemaining(order) + ' remaining') }}</span>
            </span>
          </td>
          
 <td>{{ getLocationName(order.gerber_print_location_id) }}</td>
          <td>
            <span class="tag" :class="getStatusTagClass(isCuttingComplete(order), isCuttingApplicable(order))">
              <span v-if="!isCuttingApplicable(order)" class="has-text-grey">{{ isCuttingActuallyComplete(order) ? 'Completed' : 'Not applicable' }}</span>
              <span v-else>{{ isCuttingComplete(order) ? 'Complete' : (cuttingRemaining(order) + ' remaining') }}</span>
            </span>
          </td>
          
 <td>{{ getLocationName(order.makeup_location_id) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  mixins: [OrderMixin],
  data() {
    return {
      errors: [],
      orders: [],
      loading: true,
      locations: [],
      order_by: 'deliverydate ASC',
      search: '',
      selected_location_id: 0,
      accessToken: '',
      filterStrabaneOffshore: false,
      selectedStage: null
    }
  },
  methods: {
    toNumber(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    getOrderType(order) {
      if (order.order_type) {
        return order.order_type;
      }
      if (this.toNumber(order.fully_printed) === 1) {
        return 'F/P';
      }
      if (this.toNumber(order.part_printed) === 1) {
        return 'P/P';
      }
      return '-';
    },
    getLocationName(locationId) {
      if (this.toNumber(locationId) === 1) {
        return 'Strabane';
      }
      if (this.toNumber(locationId) === 2) {
        return 'Giurgiu';
      }
      return '-';
    },
    isPrintingApplicable(order) {
      return this.toNumber(order.print_location_id) === this.toNumber(this.selected_location_id);
    },
    isRollsApplicable(order) {
      return this.toNumber(order.fabric_print_location_id) === this.toNumber(this.selected_location_id);
    },
    isCuttingApplicable(order) {
      return this.toNumber(order.gerber_print_location_id) === this.toNumber(this.selected_location_id);
    },
    printingRemaining(order) {
      return this.toNumber(order.total_qty) - this.toNumber(order.printing_papers_total);
    },
    rollsRemaining(order) {
      const rollsValue = this.toNumber(order.printing_rolls_total);
      if (rollsValue !== 0) {
        return this.toNumber(order.total_qty) - rollsValue;
      }
      return this.toNumber(order.total_qty) - this.toNumber(order.fabric_printing_papers_total);
    },
    cuttingRemaining(order) {
      const cuttingsValue = this.toNumber(order.cuttings_total);
      if (cuttingsValue !== 0) {
        return this.toNumber(order.total_qty) - cuttingsValue;
      }
      return this.toNumber(order.total_qty) - this.toNumber(order.gerber_printing_papers_total);
    },
    isPrintingComplete(order) {
      if (!this.isPrintingApplicable(order)) {
        return true;
      }
      return this.printingRemaining(order) <= 0;
    },
    isRollsComplete(order) {
      if (!this.isRollsApplicable(order)) {
        return true;
      }
      return this.rollsRemaining(order) <= 0;
    },
    isCuttingComplete(order) {
      if (!this.isCuttingApplicable(order)) {
        return true;
      }
      return this.cuttingRemaining(order) <= 0;
    },
    isPrintingActuallyComplete(order) {
      return this.printingRemaining(order) <= 0;
    },
    isRollsActuallyComplete(order) {
      return this.rollsRemaining(order) <= 0;
    },
    isCuttingActuallyComplete(order) {
      return this.cuttingRemaining(order) <= 0;
    },

    getStatusTagClass(isComplete, isApplicable = true) {
      if (!isApplicable) {
        return 'is-grey';
      }
      return isComplete ? 'is-success is-light' : 'is-warning is-light';
    },
    getOrderStage(order) {
      const printingApplicable = this.isPrintingApplicable(order);
      const rollsApplicable = this.isRollsApplicable(order);
      const cuttingApplicable = this.isCuttingApplicable(order);
      const printingComplete = this.isPrintingComplete(order);
      const rollsComplete = this.isRollsComplete(order);
      const cuttingComplete = this.isCuttingComplete(order);

      // Check each applicable process at this location in order
      if (printingApplicable && !printingComplete) {
        return 'printing_required';
      }
      if (rollsApplicable && !rollsComplete) {
        return 'fabric_rolls_required';
      }
      if (cuttingApplicable && !cuttingComplete) {
        return 'gerber_cutting_required';
      }
      
      // For waiting_makeup, check if all three processes are complete globally
      if (this.isPrintingActuallyComplete(order) && this.isRollsActuallyComplete(order) && this.isCuttingActuallyComplete(order)) {
        return 'waiting_makeup';
      }
      
      // If there are applicable processes we haven't covered above, it's waiting
      return 'waiting_makeup';
    },
    buildSummary(orders, stageKey) {
      const stageOrders = orders.filter(order => this.getOrderStage(order) === stageKey);
      return {
        orders: stageOrders.length,
        garments: stageOrders.reduce((total, order) => total + this.toNumber(order.total_qty), 0)
      };
    },
    async loadLocations() {
      const rows = await UtilityService.getSimpleApiData(this.accessToken, 'locations?printing=1&restrict_by_user=1');
      this.locations = rows || [];
    },
    async getOrders() {
        this.orders = [];
      if (!this.selected_location_id || this.toNumber(this.selected_location_id) <= 0) {
        
        this.loading = false;
        return;
      }

      this.loading = true;

      OrderService.getPrintingCuttingOrders(
        this.accessToken,
        this.selected_location_id,
        '',
        this.order_by,
        '',
        '',
        1
      ).then(
        (orders) => {
          this.$set(this, 'orders', orders || []);
          this.loading = false;
        }
      ).catch((error) => {
        this.loading = false;
        this.orders = [];
        console.log('Error loading overview report orders', error);
      });
    },
    async initialiseReport() {
      await this.getAccessToken();
      await this.loadLocations();

      const savedLocationId = localStorage.printing_overview_report_location_id;
      if (savedLocationId) {
        this.selected_location_id = Number(savedLocationId);
      } else if (this.locations.length > 0) {
        this.selected_location_id = this.locations[0].id;
      }

      //await this.getOrders(); // I have removed this because it is called in the watch of selected_location_id, which will be triggered when we set it above
    },
    toggleStage(stageKey) {
      this.selectedStage = this.selectedStage === stageKey ? null : stageKey;
    }
  },
  computed: {
    filteredOrders() {
      let filteredOrders = this.orders;

      if (this.filterStrabaneOffshore) {
        filteredOrders = filteredOrders.filter(order =>
          this.toNumber(order.print_location_id) === 1 &&
          this.toNumber(order.gerber_print_location_id) != 1
        );
      }

      if (this.selectedStage) {
        filteredOrders = filteredOrders.filter(order => this.getOrderStage(order) === this.selectedStage);
      }

      if (this.search && this.search !== '') {
        const term = this.search.toLowerCase();
        filteredOrders = filteredOrders.filter(order =>
          String(order.ponumber || '').toLowerCase().includes(term)
          || String(order.clientname || '').toLowerCase().includes(term)
          || String(order.garmentname || '').toLowerCase().includes(term)
        );
      }

      return filteredOrders;
    },
    totalFilteredGarments() {
      return this.filteredOrders.reduce((total, order) => total + this.toNumber(order.total_qty), 0);
    },
    summaryRows() {
      const source = this.filteredOrders;

      const printingRequired = this.buildSummary(source, 'printing_required');
      const fabricRollsRequired = this.buildSummary(source, 'fabric_rolls_required');
      const gerberCuttingRequired = this.buildSummary(source, 'gerber_cutting_required');

      return [
        {
          key: 'printing_required',
          label: 'Printing Required',
          orders: printingRequired.orders,
          garments: printingRequired.garments,
          messageClass: 'is-link'
        },
        {
          key: 'fabric_rolls_required',
          label: 'Printed But Fabric Rolls Required',
          orders: fabricRollsRequired.orders,
          garments: fabricRollsRequired.garments,
          messageClass: 'is-link'
        },
        {
          key: 'gerber_cutting_required',
          label: 'Fabric Rolls Complete But Gerber Cutting Required',
          orders: gerberCuttingRequired.orders,
          garments: gerberCuttingRequired.garments,
          messageClass: 'is-link'
        }
      ];
    }
  },
  created() {
    this.initialiseReport();
  },
  watch: {
    selected_location_id() {
      localStorage.printing_overview_report_location_id = this.selected_location_id;
       this.getOrders();
    },

  }
}
</script>

